import { Spinner } from '@/components/ui/spinner'

export const PhotosetGenerating = ({
	title,
	subtitle
}: {
	title: string
	subtitle: string
}) => {
	return (
		<div className='flex h-full w-full flex-col items-center justify-center'>
			<div className='mx-auto mt-8 mb-6 flex w-[392px] flex-col items-center gap-3 text-center'>
				<Spinner className='fill-neutral-900' size={32} />
				<h1 className='font-bold text-2xl text-neutral-900'>{title}</h1>
				<p className='text-neutral-900 text-xl'>{subtitle}</p>
			</div>
		</div>
	)
}
